import {
  type GenerateStyle,
  genComponentStyleHook,
  type FullToken,
} from "antd/es/theme/internal";
import { tabsPrefixCls } from "@/base/components/tabs/Tabs.component";
import { THEME_PREFIX } from "@/base/constant";

const genStyle: GenerateStyle<FullToken<"Tabs">> = ({
  titleFontWeight,
}: any) => ({
  [`.${THEME_PREFIX}`]: {
    [`&.${tabsPrefixCls}`]: {
      [`.${tabsPrefixCls}-tab`]: {
        fontWeight: titleFontWeight,
      },
    },
  },
});

export const useTabsStyle = genComponentStyleHook(["Tabs", "cso"], (token) => {
  return [genStyle(token)];
});
